import { render, staticRenderFns } from "./AccountTBPage.vue?vue&type=template&id=2e14b63c&"
import script from "./AccountTBPage.vue?vue&type=script&lang=js&"
export * from "./AccountTBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e14b63c')) {
      api.createRecord('2e14b63c', component.options)
    } else {
      api.reload('2e14b63c', component.options)
    }
    module.hot.accept("./AccountTBPage.vue?vue&type=template&id=2e14b63c&", function () {
      api.rerender('2e14b63c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accountTB/AccountTBPage.vue"
export default component.exports